import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';

import { useAppsPreviousStudies } from './use-apps-previous-studies.hook';
import { useFctPreviousStudies } from './use-fct-previous-studies.hook';

export function usePreviousStudies() {
  const isComparisonEnabled = useIsDDFeatureFlagEnabled('FCT_COMPARISON_V2');
  const appsData = useAppsPreviousStudies();
  const fctData = useFctPreviousStudies();

  return isComparisonEnabled ? fctData : appsData;
}
